import request from './http';
export const login = (data) => request({
  url: '/jetlinks/authorize/login',
  method: 'POST',
  data: data
});

export const loginout = () => request({
  url: '/jetlinks/user-token/reset',
  method: 'GET'
});

export const get_captch = () => request({
    url: '/jetlinks/authorize/captcha/image?width=130&height=30',
    method: 'GET'
})
